import React from 'react';

import { PIN_PROP, AGENCY_PROJECT, PAGE_SERP_MAP } from '../utils/Constants';
import { useDeviceDetection } from '../utils/DeviceDetection';
import { OverlayView, Marker } from '@react-google-maps/api';
import InfoWindow from './InfoWindow';
import { useGoogleMapsApi } from '../api/gis';

export default function MapResults({
	results,
	focusedResult,
	panMapToFocusedResult,
	onToggleInfoWindow,
	page,
	onCalcRouteClick,
	onStreetViewClick,
	onDetailClick,
	autocompleteResult
}) {
	const google = useGoogleMapsApi();
	const isMobile = useDeviceDetection();

	const [markers, setMarkers] = React.useState([]);
	const [loadedInfoWindow, setLoadedInfoWindow] = React.useState(null);

	React.useEffect(() => {
		if (loadedInfoWindow) panMapToFocusedResult(loadedInfoWindow);
	}, [loadedInfoWindow]);

	React.useEffect(() => {
		const mar = markers[markers.length - 1];
		if (mar) mar.setMap(null);
	}, [autocompleteResult]);

	function getMarkerOptions(result, isFocused) {
		const pin = result.pin;
		const pinURL = isFocused
			? pin.highlighted && pin.highlighted.startsWith('http')
				? pin.highlighted
				: require('../images/pin/' + pin.highlighted)
			: pin.main && pin.main.startsWith('http')
			? pin.main
			: require('../images/pin/' + result.pin.main);

		return {
			icon: {
				url: pinURL,
				size: new google.maps.Size(
					isFocused ? PIN_PROP.HIGHLIGHTED.width : PIN_PROP.width,
					isFocused ? PIN_PROP.HIGHLIGHTED.height : PIN_PROP.height
				),
				scaledSize: new google.maps.Size(
					isFocused ? PIN_PROP.HIGHLIGHTED.width : PIN_PROP.width,
					isFocused ? PIN_PROP.HIGHLIGHTED.height : PIN_PROP.height
				),
				origin: new google.maps.Point(0, 0),
				anchor: new google.maps.Point(
					isFocused ? PIN_PROP.HIGHLIGHTED.anchorX : PIN_PROP.anchorX,
					isFocused ? PIN_PROP.HIGHLIGHTED.anchorY : PIN_PROP.anchorY
				)
			}
		};
	}

	function openInfoWindowProcess(result, markerPos) {
		// Commentato in data 03/06/21
		// TODO indagare: perchè c'era questo pezzo?? markerPos a che serve??
		// console.log('MARKER:', markers, markerPos);
		// if (markers[markerPos]) {
		// 	markers[markerPos].setIcon(
		// 		require('../images/pin/' +
		// 			PIN_PROP.IMGs[AGENCY_PROJECT].highlighted)
		// 	);
		// }
		onToggleInfoWindow(result);
		// if (loadedInfoWindow) {
		// 	loadedInfoWindow.onRemove();
		// }
	}

	return (
		<>
			{page === PAGE_SERP_MAP && results
				? results.map((result, index) => {
						return result.lat && result.lng ? (
							<Marker
								position={{
									lat: result.lat,
									lng: result.lng
								}}
								options={getMarkerOptions(
									result,
									focusedResult &&
										focusedResult.id === result.id
								)}
								animation={google.maps.Animation.DROP}
								onClick={() =>
									openInfoWindowProcess(result, index)
								}
								onLoad={(marker) => {
									markers[index] = marker;
									setMarkers(markers);
								}}
								key={result.id}
							></Marker>
						) : null;
				  })
				: null}
			{page === PAGE_SERP_MAP && autocompleteResult ? (
				<Marker
					position={{
						lat: autocompleteResult.lat,
						lng: autocompleteResult.lng
					}}
					options={getMarkerOptions(
						autocompleteResult,
						focusedResult &&
							focusedResult.id === autocompleteResult.id
					)}
					animation={google.maps.Animation.DROP}
					onClick={() =>
						openInfoWindowProcess(
							autocompleteResult,
							markers.length - 1
						)
					}
					onLoad={(marker) => {
						markers[markers.length] = marker;
						setMarkers(markers);
						openInfoWindowProcess(
							autocompleteResult,
							markers.length - 1
						);
					}}
					key={autocompleteResult.id}
				></Marker>
			) : null}
			{page === PAGE_SERP_MAP && !isMobile && focusedResult ? (
				<OverlayView
					key={focusedResult.id}
					position={{
						lat: focusedResult.lat,
						lng: focusedResult.lng
					}}
					mapPaneName={OverlayView.FLOAT_PANE}
					getPixelPositionOffset={(width, height) => {
						return {
							x: -(width / 2),
							y: -height - PIN_PROP.height - 25
						};
					}}
					onLoad={(overlayView) => {
						setLoadedInfoWindow(overlayView);
					}}
					onUnmount={() => {
						setLoadedInfoWindow(null);
					}}
				>
					<InfoWindow
						result={focusedResult}
						onClose={onToggleInfoWindow}
						onCalcRouteClick={onCalcRouteClick}
						onDetailClick={onDetailClick}
						onStreetViewClick={onStreetViewClick}
					></InfoWindow>
				</OverlayView>
			) : null}
		</>
	);
}
